import React, {PureComponent} from 'react'
import {connect} from 'react-redux'

import Page from '../components/app/page'

import {loadOrganizations, createOrganization, updateOrganization, deleteOrganization } from '../actions/organizations'

import {DataTable, DataColumn} from '../components/ui/dataTable'
import Toolbar from '../components/app/toolbar'
import Button from '../components/ui/button'
import Pagination from '../components/ui/pagination'

import {DateCell, ControlsCell} from '../components/ui/dataCells'

import OrganizationsModal from '../components/organizations/organizationModal'
import { PATH_ORGANIZATIONS_LIST_PAGE , getLink} from '../routes'


const mapStateToProps = (state)=>{
    return {
        organizations: state.organizations.organizations,
        organizationsCount: state.organizations.organizationsCount
    }
}

class OrganizationsPage extends PureComponent{
    constructor(){
        super()
        this.state = {showModal: false}
    }
    loadOrganizations = ({page, sortBy, sortDirection})=>{
        this.props.dispatch(loadOrganizations({page, sortBy, sortDirection})) 
    }
    componentDidMount(){
        const {match:{params:{page}}} = this.props
        this.loadOrganizations({page})
    }
    componentWillReceiveProps(props){
        const {match:{params:{page}}} = props
        const {sortDirection, sortBy} = this.state
        if(page != this.props.match.params.page){
            this.loadOrganizations({page, sortBy, sortDirection})
        }   
    }
    onSort = ({sortBy, sortDirection})=>{
        this.setState({sortBy, sortDirection})
        const {match:{params:{page}}} = this.props
        this.loadOrganizations({sortBy, sortDirection, page})
    }
    onEdit = ({rowData})=>{
        console.log('edit organization', rowData)
        this.setState({showModal: true, organization: rowData})
    }
    
    onCreate = ()=>{
        this.setState({showModal: true, organization: null})
    }
    onCloseModal =()=>{
        this.setState({showModal: false, organization: null})
    }
    onConfirmCreate =async({name, organization})=>{
        if(organization){
            organization = await this.props.dispatch(updateOrganization({organization, name}))
        }else{
            organization = await this.props.dispatch(createOrganization({name}))
        }
        if(organization){
            this.onCloseModal()
        }
    }
    onRemove = ({rowData})=>{
        if(window.confirm('Sind sie sicher, dass sie dieses Unternehmen löschen wollen?')){
            this.props.dispatch(deleteOrganization({organization: rowData}))
        }
    }

    getPageLink = ({index})=>{
        return getLink(PATH_ORGANIZATIONS_LIST_PAGE, {page: index})
    }

    render(){
        const {organizations = [], organizationsCount, match: {params:{page}}} = this.props
        const {showModal, organization, sortBy, sortDirection} = this.state
        console.log('render users', organizations)
        return (<Page title="Organizations" container>
            <Toolbar title="Organizations" meta={organizationsCount + ' Total'} controls={[
                <Button onClick={this.onCreate} key="create-btn">Neues Unternehmen</Button>
            ]}/>
            <DataTable data={organizations} onSort={this.onSort} sortBy={sortBy} sortDirection={sortDirection}>
                <DataColumn width={200} flexGrow={1} label="Name" dataKey="name" sortable />
                <DataColumn width={100} flexGrow={1} label="Erstellt am" dataKey="createdAt" cellRenderer={DateCell}  />
                <DataColumn width={100} flexGrow={1} label="Geändert am" dataKey="updatedAt" cellRenderer={DateCell}  />
                <DataColumn width={100} flexGrow={1} label="" dataKey="controls" cellRenderer={({rowData}) => <ControlsCell rowData={rowData} onEdit={this.onEdit} onRemove={this.onRemove} />} />
            </DataTable>
            <Pagination getPageLink={this.getPageLink} perPage={100} page={page} itemCount={organizationsCount} />
            <OrganizationsModal organization={organization} isOpen={showModal} onRequestClose={this.onCloseModal} onConfirm={this.onConfirmCreate} />
        </Page>)
    }
}

export default connect(mapStateToProps)(OrganizationsPage)


// WEBPACK FOOTER //
// ./src/pages/organizations.js